import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EventItem } from '../../../../shared/interfaces/event';
import { ExamAndTaskCalenderItem } from 'src/app/models/ExamsAndTasksCalendar/examAndTaskCalenderItem';

@Component({
  selector: 'app-my-month',
  templateUrl: './my-month.component.html',
  styleUrls: ['./my-month.component.scss']
})
export class MyMonthComponent {
  @Input({ required: true }) widgetData!: any;
  @Output() dayItemClicked = new EventEmitter<Date>();
  monthEvents: { date: string, events: EventItem[] }[] = [];
  isLoading: boolean = false;

  calendarEventsLoded(events: ExamAndTaskCalenderItem[]) {
    let groupedByDay: { [day: string]: typeof events } = {};
    events.forEach(event => {
      let day = event.date.split('T')[0];
      if (!groupedByDay[day]) {
        groupedByDay[day] = [];
      }
      groupedByDay[day].push(event);
    });

    let entries = Object.entries(groupedByDay);
    entries.sort((a, b) => {
      let dateA = new Date(a[0]);
      let dateB = new Date(b[0]);
      return dateA.getTime() - dateB.getTime();  // For ascending order
    });
    let sortedGroupedByDay: { [day: string]: typeof events } = {};
    entries.forEach(entry => {
      sortedGroupedByDay[entry[0]] = entry[1];
    });

    this.monthEvents = Object.keys(sortedGroupedByDay).map(key => {
      return {
        date: sortedGroupedByDay[key][0]?.date,
        events: sortedGroupedByDay[key].map(event => {
          return {
            title: event.courseName,
            description: event.description,
            date: event.date,
            link: event.linkUrl,
            type: event.calenderDataType,
            startTime: this.getTimeFromDate(event.date),
            endTime: this.getTimeFromDate(event.endDate!),
            location: event.location,
            sendToDate: event.assignmentSubmissionDate ?? undefined,
            gpsX: event.gpsX,
            gpsY: event.gpsY,
            notifications: event.notifications
          }
        })
      }
    });
  }

  private getTimeFromDate(dateStr: string): string {
    if (dateStr.endsWith('Z')) {
      dateStr = dateStr.replace('Z', '');
    }

    let date = new Date(dateStr);
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  dayItemClickedHandler(date: Date) {
    this.dayItemClicked.emit(date);
  }

  loadingStateChangedHandler(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
